import React from "react";
import {FieldProps} from "formik";
import {Box, InputAdornment, Typography} from "@mui/material";
import {TextField} from "formik-mui";
import {flagStyles} from "../styles/flag.styles";
import CountryInfo from "./data/Flags/CountryInfo";

interface TelefonnummerInputProps extends FieldProps {
    label: string;
    required?: boolean;
    country: CountryInfo;
}

const TelefonnummerInput = ({
                                field,
                                form,
                                meta,
                                label,
                                required = false,
                                country,
                            }: TelefonnummerInputProps) => {
    return (
        <TextField
            field={field} form={form} meta={meta} fullWidth
            label={label + (required ? " *" : "")}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Box sx={flagStyles.adornmentBox}>
                            <Box sx={flagStyles[country.flagKey ?? "default"]}>
                                {country.flag}
                            </Box>
                            <Typography sx={flagStyles.prefix}>
                                {country.prefix}
                            </Typography>
                        </Box>
                    </InputAdornment>
                ),
            }}
            inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 15,
            }}/>
    );
};

export default TelefonnummerInput;